module.exports = __webpack_public_path__ + "img/agriculture.96141af5.png";